import React, { Component } from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import dayjs from 'dayjs'
import axios from 'axios'
import settings from '../../settings'
import { swalInfo } from '../../common/components/Swaler'

// const translate = {
//     sendBack: 'en retur',
//     change: 'ett byte',
//     asap: 'Express',
//     suitable: 'Standard'
// }

var boldElement = str => {
    return <span style={{ fontWeight: 800 }}>{str}</span>
}

class RentalRowItem extends Component {
    state = {
        expanded: false,
    }

    showCustomerDetails = (customer) => {
        let title = `${customer.name} ${customer.surname}`
        let html = `<p>${customer.email}</p><p>${customer.phone}</p>`
        swalInfo(title, html)
    }

    toggleExpand = (e) => {
        this.setState({ expanded: !this.state.expanded })
    }

    getPhoto = (key) => {
        const url = `${window.MYQLOCX_API}/rental/photo/${key}`
        axios.get(encodeURI(url)).then(t => {
            console.log(t.data)
            window.open(t.data, '_blank')
        }).catch(function (e) {
            console.log(e)
        })
    }

    render() {
        const { item } = this.props

        return (
            <Row className="delivery-item-height lock-list" style={{ borderRadius: 20, width: '100%', marginBottom: 10 }}>
                <Col xs={1} md={1} className="delivery-item-logo">
                    <div style={{ display: "block", margin: "auto", marginTop: 10 }}>{item.rentalCompany.image ? <img style={{ display: "block", margin: "auto" }} className="img-logo" src={item.rentalCompany.image} /> : "LOGO"}</div>
                </Col>
                <Col xs={6} md={6} style={{ paddingTop: "2%" }}>
                    <p><span style={{ cursor: 'pointer' }} onClick={() => this.showCustomerDetails(item.customer)}>{boldElement(`${item.customer.name} ${item.customer.surname} (${item.userCompanyName || 'Okänt företag'})`)}</span> genomförde {this.props.translations[item.SelectAction]} från {boldElement(item.lock.custom_name)} innehållande {boldElement(`${item.deviceSerialNumbers.length} verktyg`)}</p>
                </Col>
                <Col xs={3} md={3} style={{ paddingTop: "1%" }}>
                    <div style={{ cursor: 'pointer', textAlign: 'center', border: '1px solid #afafaf', borderRadius: 10, color: '#006e78', width: '80%', padding: 10, backgroundColor: this.state.expanded ? 'lightgrey' : 'white' }} onClick={this.toggleExpand}>
                        Visa mer
                    </div>
                </Col>
                <Col xs={2} md={2} style={{ paddingTop: "2%" }}>
                    {dayjs(item.created).format('D/MM - YY kl HH:mm')}
                </Col>

                {this.state.expanded && (
                    <Col xs={12} md={12} lg={12} style={{ padding: '10px 50px 50px 50px' }}>
                        <hr />

                        <p>{boldElement('Serienummer/beskrivning:')}</p>
                        {item.deviceSerialNumbers.map((number, i) => {
                            return <p key={i}>{number}</p>
                        })}
                        <br />

                        <p>{boldElement('Project number:')}</p>
                        <p>
                            {item.projectNumber || '-'}
                        </p>
                        <br />

                        <p>{boldElement('Comment:')}</p>
                        <p>
                            {item.comment || '-'}
                        </p>
                        <br />

                        <p>{boldElement('Bilder:')}</p>
                        {item.photoKeys.map((key, i) => (
                            <p style={{ color: '#006e78', cursor: 'pointer' }} key={key} onClick={() => this.getPhoto(key)}>{`Bild ${i + 1}`}</p>
                        ))}

                        {item.approval && <p>{`Har blivit bekräftad ${dayjs(item.approval.date).format('DD/MM/YYYY HH:mm')} av ${item.approval.signer || 'Okänd'}`}</p>}
                    </Col>
                )}
            </Row>
        )
    }
}

export default React.memo(RentalRowItem)
